import File_settingsModel from '../Apis/File_settings'
import Controller from './Controller'

export default class File_settingsController extends Controller {
  constructor() {
    super(new File_settingsModel())
  }
}
